import { decryptedData, getConfigFromStroage } from "../utils/getUrlsFromAws";
import { env } from './../env/env';

const appHeaders = {
    qualTechDev: 'U8eL0A3syl3wPN0U1tMuN7OJH66cXw0llUlC4deg',
    mliDev: 'niu7mbEQoX1rGcOOEEOVV4x289vK8MT89D5Dd0nR',
    mliUat: 'VUukasqEIe7VjquvpqFy84K43WsYsVjM4fb2xps7',
    mliProd: 'uyp3aFwF3t6nchnVgKfQt5zx8lfSKjNq6V2feotG'
}

const uploadApiHeaders = {
    qualTechDev: 'cap5o790t57LdNLuF99Vt40Vn2FvsFB50463bDq0',
    // mliDev: 'cap5o790t57LdNLuF99Vt40Vn2FvsFB50463bDq0',
    mliDev: 'Y5Sc5VIlrj76GPYBsRNHM6tekMlegLmu6Tl6hpNf',
    mliUat: 'Y5Sc5VIlrj76GPYBsRNHM6tekMlegLmu6Tl6hpNf',
    mliProd: 'uyp3aFwF3t6nchnVgKfQt5zx8lfSKjNq6V2feotG'
}

const clientIds = {
    qualTechDev: '41dil804kos0g5eo7d5i6hbgb',
    // mliDev:'41dil804kos0g5eo7d5i6hbgb',
    mliDev: '2ifamm0gv1o1k2bkfshtf9rdhb',
    mliUat: '2ifamm0gv1o1k2bkfshtf9rdhb',
    mliProd: '5taj785lq9ffds4di8m8pmb8mt'
}

const clientSecrets = {
    qualTechDev: '13sqqqu0c07pssab1e2ndakuen03u2b9l00mftp5ep1mr2v139br',
    // mliDev:'13sqqqu0c07pssab1e2ndakuen03u2b9l00mftp5ep1mr2v139br',
    mliDev: 'm0un91skurd4nvneqq03uk8donkhf7argnflveirtflban1473j',
    mliUat: 'm0un91skurd4nvneqq03uk8donkhf7argnflveirtflban1473j',
    mliProd: '1nh3kdi1ute3k25ha4kfnee5qjiktngpb5g5iiuap5gpn106915v'
}

export const getCredentials = () => {
    // const clientId = clientIds[env]
    // const clientSecret = clientSecrets[env]
    let clientId = "";
    let clientSecret = "";
    let urlsData = getConfigFromStroage();
    if (urlsData) {
      clientId = decryptedData(urlsData["getTokenClientId"]);
      clientSecret = decryptedData(urlsData["getTokenClientSecret"]);
    }
    return { clientId, clientSecret }
}

export const getUploadHeader = () => {
    let urlsData = getConfigFromStroage();
    if (urlsData) {
      return decryptedData(urlsData["xApiKeyUploadVideo"]);
    } else {
      return "";
    }
    // return uploadApiHeaders[env]
}

export const getHeader = () => {
    let urlsData = getConfigFromStroage();
    if (urlsData) {
        return decryptedData(urlsData["xApiKey"]);
    } else {
        return "";
    }
    // return appHeaders[env];
}

export const headers = {
    'x-api-key': getHeader()
}